export const theme = {
	token: {
		//   colorPrimary: '#00b96b',
	},

	// cssVar.key 必须写死，否则 antd 会用 React 的 useId() 生成，而 useId 在
	// 「纯客户端渲染」与「hydration」两种模式下前缀不同（r1 / R17）。react-snap 的
	// 产物是客户端渲染出来的，存进 HTML 的键与用户浏览器 hydrate 时算出的键不一致。
	//
	// 2026-10-21 审查时做过移除实验，结论是**必须保留**，证据：
	//   带此配置：产物 156 处全是稳定的 css-var-root
	//   去掉之后：产物出现 241 处 css-var-r1（useId 派生）+ 30 处 css-var-root
	// 注意两点，免得下次又有人误判它没用：
	//   1. 产物里看不到 "ycy" 本身（css-var-ycy 实测 0 次）——不要据此认为配置没生效，
	//      真正的判据是「有没有出现 r1 这种 useId 形态」。
	//   2. 生产版 React 不报 className 不匹配（那是 dev-only 警告），所以
	//      scripts/check-hydration.js 在两种产物上都报干净，**它查不出这一项**，
	//      只能靠直接 grep 产物里的 css-var 前缀。
	cssVar: { key: "ycy" },
};
